(function() {
    'use strict';
    
a3_cabin_reports.factory('WifiVouchersFactory', WifiVouchersFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name WifiVouchersFactory
    * @description 
    * Get Wifi VouchersFactory.
    * @ngInject
    */ 
function WifiVouchersFactory($http, apiUrl) {
    var submitResponseObj = { success: false, message: '', data: '' }

    var service = {
        retrieveWifiVouchers: retrieveWifiVouchers,
        createWifiVoucher: createWifiVoucher
    };

    /**
     * Retrieve Wifi Vouchers
     * @memberof WifiVouchersFactory
     * @param {function} callback  
     */
    function retrieveWifiVouchers(requestObj) {
        var objectToAdd = requestObj;
        return $http.post(apiUrl + '/WifiVouchers/RetrieveVouchers/', requestObj, { 'Content-Type': 'application/json' })
        .then(res => retrieveVouchersSuccessCallBack(res, objectToAdd))
        .catch(res => vouchersFailedCallBack(res));      
    } 

    /**
     * The callback function upon successful retrieve
     * @param {object} res 
     * @param {object} objectToAdd 
     * @returns {object} submitResponseObj
     */
    function retrieveVouchersSuccessCallBack(res, objectToAdd) {
        submitResponseObj.success = res.data.success;
        if (res.data.success && objectToAdd.PNR != null) {      
            submitResponseObj.message = "Success! Your input has been sent";
            submitResponseObj.data = res.data.data.Result;
        }
        else if (res.data.success && objectToAdd.PNR == null){
            submitResponseObj.message = "You have to fill PNR No";
        }       
        else{
            submitResponseObj.message = res.data.errorMessage
        }
        return submitResponseObj;
    }

    /**
     * Create Wifi Vouchers
     * @memberof WifiVouchersFactory
     * @param {function} callback  
     */
    function createWifiVoucher(requestObj) {
        var objectToAdd = requestObj;

        return $http.post(apiUrl + '/WifiVouchers/CreateVoucher/', requestObj, { 'Content-Type': 'application/json' })
        .then(res => createVouchersSuccessCallBack(res, objectToAdd))
        .catch(res => vouchersFailedCallBack(res));     
    }

    function createVouchersSuccessCallBack(res, objectToAdd) {
        submitResponseObj.success = res.data.success;
        if (res.data.success && objectToAdd.PNR != null && res.data.data.Result && res.data.data.Result.Vouchers) {      
            submitResponseObj.message = "Success! Your input has been sent";
            submitResponseObj.data = res.data.data.Result.Vouchers;
        }
        else{
            submitResponseObj.message = res.data.errorMessage
        }
        return submitResponseObj;
    }
    
    /**
    * The callback function upon failure on retrieve
    * @returns {object} submitResponseObj
    */
     function vouchersFailedCallBack(res) {
        submitResponseObj.success = false;
        submitResponseObj.message = "Oops! Something went wrong"
        return submitResponseObj;
    }
    return service;
}
})();